import debounce from 'lodash/debounce';

export default class MouseTrail {
  constructor(canvasEl) {
    this.lines = [];
    this.lastPosition = {
      x: window.innerHeight / 2,
      y: window.innerHeight / 2,
    };
    this.mousePos = { x: 0, y: 0 };
    this.maxLines = 60;

    this.startColor = [328.1, 53.9, 45.1]; // hsl
    this.endColor = [367.9, 93.8, 62]; // hsl - using 367 to so that colour wraps around
    this.colors = [];

    this.canvasEl = canvasEl;
    this.context = this.canvasEl.getContext('2d');
    this.context.canvas.width = window.innerWidth;
    this.context.canvas.height = window.innerHeight;

    this.circles = [];
    this.circleFadeRate = 0.015;
    this.circleMaxSize = 400;
    this.circleExpandRate = 1.4;

    this.calculateColors();

    document.addEventListener(
      'mousemove',
      () => {
        this.mousePos = this.getMousePos(this.canvasEl, event);
      },
      false
    );

    document.addEventListener('click', () => {
      this.circles.push({
        x: this.mousePos.x,
        y: this.mousePos.y,
        a: 1,
        size: 0,
      });
    });

    window.addEventListener(
      'resize',
      debounce(
        function() {
          this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
          this.context.canvas.width = window.innerWidth;
          this.context.canvas.height = window.innerHeight;
        }.bind(this)
      ),
      200
    );

    this.draw();
  }

  getMousePos(canvas, event) {
    let rect = canvas.getBoundingClientRect();

    return {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
    };
  }

  draw() {
    this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);

    this.lines.push({
      start: {
        x: this.lastPosition.x,
        y: this.lastPosition.y,
      },
      end: this.mousePos,
    });

    if (this.lines.length > this.maxLines) {
      this.lines.shift();
    }

    for (let i = 0; i < this.lines.length; i++) {
      let line = this.lines[i];

      this.context.beginPath();
      this.context.strokeStyle = this.colors[i];
      this.context.lineWidth = 2;
      this.context.moveTo(line.start.x, line.start.y);
      this.context.lineTo(line.end.x, line.end.y);
      this.context.stroke();
    }

    this.lastPosition = this.mousePos;

    for (let i = 0; i < this.circles.length; i++) {
      this.circles[i].size += this.circleExpandRate;
      this.circles[i].a -= this.circleFadeRate;
      this.context.beginPath();
      this.context.strokeStyle = `hsla(367.9, 93.8%, 62%, ${this.circles[i].a})`;
      this.context.lineWidth = 2;
      this.context.arc(this.circles[i].x, this.circles[i].y, this.circles[i].size, 0, 2 * Math.PI);
      this.context.stroke();

      if (this.circles[i].a <= 0) {
        this.circles.splice(i, 1);
      }
    }

    window.requestAnimationFrame(this.draw.bind(this));
  }

  lerp(a, b, t) {
    return a * (1 - t) + b * t;
  }

  calculateColors() {
    for (let i = 0; i < this.maxLines; i++) {
      let hue = this.lerp(this.startColor[0], this.endColor[0], i / this.maxLines);
      let sat = this.lerp(this.startColor[1], this.endColor[1], i / this.maxLines);
      let light = this.lerp(this.startColor[2], this.endColor[2], i / this.maxLines);
      let alpha = this.lerp(0, 1, i / this.maxLines);

      this.colors.push(`hsla(${hue}, ${sat}%, ${light}%, ${alpha})`);
    }
  }
}
